import type { CampusEvent, StudentOrganization } from '../types/campus'

export const events: CampusEvent[] = [
  {
    id: 'evt-1',
    title: 'Engineering Week — opening lecture',
    organizer: 'Faculty of Engineering',
    category: 'Academic',
    date: '2026-08-17',
    dateLabel: 'Mon 17 Aug',
    time: '10:00 — 12:00',
    venue: 'Main Auditorium',
    ticket: 'Free',
    capacity: 800,
    registered: 512,
    registeredByMe: true,
  },
  {
    id: 'evt-2',
    title: 'Lagos Tech Careers Fair',
    organizer: 'Careers and Counselling Unit',
    category: 'Career',
    date: '2026-08-19',
    dateLabel: 'Wed 19 Aug',
    time: '09:00 — 16:00',
    venue: 'Sports Complex',
    ticket: 'Free',
    capacity: 1500,
    registered: 1187,
    registeredByMe: false,
  },
  {
    id: 'evt-3',
    title: 'Inter-faculty football final',
    organizer: 'Sports Council',
    category: 'Sports',
    date: '2026-08-22',
    dateLabel: 'Sat 22 Aug',
    time: '16:00 — 18:00',
    venue: 'Main Bowl',
    ticket: 'Paid',
    price: 1000,
    capacity: 4000,
    registered: 2340,
    registeredByMe: false,
  },
  {
    id: 'evt-4',
    title: 'SESA general meeting',
    organizer: 'Systems Engineering Students Association',
    category: 'Association',
    date: '2026-08-18',
    dateLabel: 'Tue 18 Aug',
    time: '17:00 — 18:30',
    venue: 'Engineering LT2',
    ticket: 'Free',
    capacity: 300,
    registered: 96,
    registeredByMe: true,
  },
  {
    id: 'evt-5',
    title: 'Campuzon Hackathon — housing data track',
    organizer: 'Campuzon Technologies',
    category: 'Competition',
    date: '2026-08-29',
    dateLabel: 'Sat 29 Aug',
    time: '08:00 — 20:00',
    venue: 'CIT Innovation Hub',
    ticket: 'Paid',
    price: 2500,
    capacity: 120,
    registered: 118,
    registeredByMe: false,
  },
  {
    id: 'evt-6',
    title: 'Final-year send-forth mixer',
    organizer: 'Students Union',
    category: 'Social',
    date: '2026-09-05',
    dateLabel: 'Sat 5 Sep',
    time: '19:00 — 23:00',
    venue: 'Student Centre',
    ticket: 'Paid',
    price: 3500,
    capacity: 600,
    registered: 208,
    registeredByMe: false,
  },
]

export const organizations: StudentOrganization[] = [
  {
    id: 'org-1',
    name: 'Systems Engineering Students Association',
    category: 'Departmental',
    members: 640,
    description: 'Departmental body running tutorials, past-paper archives and the annual design competition.',
    joined: true,
  },
  {
    id: 'org-2',
    name: 'UNILAG Robotics Club',
    category: 'Technical',
    members: 210,
    description: 'Weekly build sessions and the national robotics competition team.',
    joined: false,
  },
  {
    id: 'org-3',
    name: 'Women in Engineering',
    category: 'Community',
    members: 385,
    description: 'Mentoring, industry talks and a scholarship support circle.',
    joined: true,
  },
  {
    id: 'org-4',
    name: 'Debate and Literary Society',
    category: 'Cultural',
    members: 152,
    description: 'Inter-faculty debating, public speaking clinics and the annual literary night.',
    joined: false,
  },
]
